import { Scope } from 'informed';
import { PropTypes } from 'prop-types';
import { Children, useState } from 'react';

import { ButtonSubtle } from 'Buttons';
//
// NOTE: Consuming developer should not need to be aware of this component.
//       It should be unknown and invisible if it is to remain part of the codebase.
//
const FilterCategory = ({
  ariaLabel,
  children,
  expanded,
  id,
  label,
  limit,
}) => {
  const [allChildrenVisible, setAllChildrenVisible] = useState(expanded);

  const toggleChildren = () => setAllChildrenVisible(!allChildrenVisible);

  const filteredChildren = Children.map(children, (child) => {
    if (child.props.count !== 0) {
      return child;
    }
    return null;
  });

  return (
    <div className="mb-6">
      <p className="font-semibold">{label}</p>
      <Scope scope={id}>
        <fieldset>
          <legend className="sr-only">{ariaLabel}</legend>
        </fieldset>
        <div aria-expanded={allChildrenVisible}>
          {filteredChildren.map((child, i) => (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={i}
              style={{
                display: !allChildrenVisible && i >= limit ? 'none' : 'block',
              }}
            >
              {child}
            </div>
          ))}
        </div>
      </Scope>
      {Children.count(filteredChildren) > limit && (
        <ButtonSubtle
          className="p-0 font-normal rounded-none cursor-pointer text-blue-3 hover:bg-white hover:bg-opacity-0 hover:border-white hover:border-opacity-0"
          onClick={toggleChildren}
          size="small"
        >
          {allChildrenVisible ? '- Show Less' : '+ Show More'}
        </ButtonSubtle>
      )}
    </div>
  );
};

FilterCategory.defaultProps = {
  expanded: false,
  limit: 5,
};

FilterCategory.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  expanded: PropTypes.bool,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  limit: PropTypes.number,
};

export default FilterCategory;
